import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { BaseEntity } from '@/types';

export type RecurringAppointmentDTO = {
  businessUserId: string;
  startTime: string;
  duration: number;
  recurringFrequency: string;
  recurringCount: string;
};
export type RecurringAppointmentByIdDTO = {
  appointmentId: string;
  uid?: string;
  duration?: number;
};
export type Slot = { start: string; end: string; status: string };
export type RecurringAppointment = {
  startTime: string;
  endTime: string;
  status: string;
  isDeleted?: boolean;
  isUpcoming?: boolean;
  slots?: Slot[];
} & BaseEntity;
export const getRecurringAppointments = (
  data: RecurringAppointmentDTO
): Promise<RecurringAppointment[]> => {
  return axios.post(`/business/calendar/availability/recurring`, data);
};

type UseGetRecurringAppointmentsOption = {
  config?: MutationConfig<typeof getRecurringAppointments>;
};

export const useGetRecurringAppointments = ({ config }: UseGetRecurringAppointmentsOption = {}) => {
  return useMutation({
    ...config,
    mutationFn: getRecurringAppointments,
  });
};

export const getRecurringAppointmenstById = (
  data: RecurringAppointmentByIdDTO
): Promise<RecurringAppointment[]> => {
  return axios.get(
    `/business/calendar/appointment/${data.appointmentId}/recurring/slots?uid=${data.uid}&duration=${data.duration}`
  );
};

type UseGetRecurringAppointmentsByIdOption = {
  config?: MutationConfig<typeof getRecurringAppointmenstById>;
};

export const useGetRecurringAppointmentsById = ({
  config,
}: UseGetRecurringAppointmentsByIdOption = {}) => {
  return useMutation({
    ...config,
    mutationFn: getRecurringAppointmenstById,
  });
};
